<template>
    <div class="footer-area" style="background-color: #2c3e50;color: #989bad;" id="footer-1">
        <div class="footer-top-area " style="background:#2c3e50" >
            <div class="footer-shape">
                <span class="shape shape1 wow fadeInUp animated" data-wow-delay="1.5s" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-delay: 1.5s; animation-name: fadeInUp;">
                    <img width="463" height="522" loading="lazy" src="https://netsparks.online/wp-content/themes/revieweb/assets/element/footer-shape-1.png" alt="footer-shape">
                </span>
                <span class="shape shape2 wow fadeInUp animated" data-wow-delay="1.5s" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-delay: 1.5s; animation-name: fadeInUp;">
                    <img width="234" height="234" loading="lazy" src="https://netsparks.online/wp-content/themes/revieweb/assets/element/footer-shape-2.png" alt="footer-shape">
                </span>
                <span class="shape shape3 wow fadeInUp animated" data-wow-delay="1.5s" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-delay: 1.5s; animation-name: fadeInUp;">
                    <img width="234" height="234" loading="lazy" src="https://netsparks.online/wp-content/themes/revieweb/assets/element/footer-shape-2.png" alt="footer-shape">
                </span>
                <span class="shape shape4 wow fadeInUp animated" data-wow-delay="1.5s" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-delay: 1.5s; animation-name: fadeInUp;">
                    <img width="112" height="112" loading="lazy" src="https://netsparks.online/wp-content/themes/revieweb/assets/element/footer-shape-4.png" alt="footer-shape">
                </span>		
                <span class="shape shape5 wow fadeInUp animated" data-wow-delay="1.5s" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-delay: 1.5s; animation-name: fadeInUp;">
                    <img width="574" height="144" loading="lazy" src="https://netsparks.online/wp-content/themes/revieweb/assets/element/footer-shape-5.png" alt="footer-shape">
                </span>
            </div>
            <div class="footer-content-area">
                <div class="container">			
                    <div class="row">
                        <div class="col-12">
                            <div id="text-3" class="widget widget_text">			
                                <div class="textwidget">
                                    <h1 style="color: #fff;">SmartNett</h1>
                                </div>
                            </div>
                            <div id="rt-about-social-2" class="widget rt_footer_social_widget">		
                                <div class="rt-about-widget">
                                    <div class="footer-about">Transform Your Business with a Tailored CRM Solution!</div>
                                        <ul class="footer-social">
                                            <li><a href="" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#989bad" d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg></a></li>
                                            <li><a href="" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#989bad" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a></li>
                                            <li><a href="" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#989bad" d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg></a></li>
                                            <li><a href="" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#989bad" d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"/></svg></a></li>
                                            <li><a href="" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#989bad" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg></a></li>			
                                        </ul>
                                    </div>
                                </div>
                            </div>			
                        </div>			
                    </div>
                </div>
                <div class="footer-copyright-area">
                    <div class="container">
                        <div class="copyright-area copyright-on menu-on">
                            <div class="copyright">Copyright © 2025 SmartNett Group. All Rights Reserved</div>
                            <div class="copyright-menu">
                                <div id="nav_menu-6" class="widget widget_nav_menu">
                                    <div class="menu-copyright-menu-container">
                                        <ul id="menu-copyright-menu" class="menu">
                                            <li id="menu-item-6370" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6370">
												<a>Terms and Conditions</a>
												<!-- <a href="https://netsparks.online/terms-and-conditions/">Terms and Conditions</a> -->
											</li>
                                            <li>|</li>
                                            <li id="menu-item-6369" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6369">
												<!-- <a href="https://netsparks.online/privacy-policy-2/">Privacy Policy</a> -->
												<a>Privacy Policy</a>
											</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
	export default {
		name: "Foot",
		props: {
			
		},
		methods: {
			toBlog(blog) {
				this.$store.dispatch('goBlogPage', blog)
			}
		}
	}
</script>

<style scoped>
	@import "../../assets/css/badge.css";

	.footer-area {
		position: relative;
		overflow: hidden;
		display: block;
	}
	.footer-shape .shape1 {
		left: 0px;
		bottom: 1px;
	}
	.footer-shape .shape2 {
		left: 420px;
		top: 30px;
	}
	.footer-shape .shape3 {
		right: 595px;
		bottom: 30px;
	}
	.footer-shape .shape4 {
		right: 468px;
		bottom: 119px;
	}
	.footer-shape .shape5 {
		right: 66px;
		bottom: 1px;
	}
	.footer-shape .shape {
		position: absolute;
	}
	.footer-content-area {
		font-size: 16px;
		border-top: none;
		padding: 100px 0px 40px;
	}
    .container {
		width: 100%;
		/* margin-right: auto; */
		/* margin-left: auto; */
	}
    @media (min-width: 768px) {
		.container{
			max-width: 720px;
		}
	}
	@media (min-width: 576px) {
		.container{
			max-width: 540px;
		}
	}
	@media (max-width: 767px) {

		.row {
			margin: 10px 0 10px 0;
        }
		.footer-top-area {
			text-align: left !important;
		}
		.footer-content-area {
			padding-top: 80px !important;
			padding-bottom: 20px !important;
		}
		.container{
			max-width: 320px;
		}
		
	}
	@media (max-width: 1024px) and (min-width: 768px) {

		.row{
			margin: 15px 0 0 0;
		}
		
	}

	
	@media (min-width: 992px) {
	
		.container{
			max-width: 960px;
		}
	}
    @media (min-width: 1400px) {
		.container {
			max-width: 1200px !important;
		}
	}
	@media (min-width: 1200px) {
		.container{
			max-width: 1140px;
		}
	}
	.footer-area .widget_text {
		margin-bottom: 20px;
	}

	.footer-top-area .widget {
		margin-bottom: 20px;
		padding-bottom: 0px;
		width: 100%;
		position: relative;
	}
	.footer-content-area * {
		text-align: center;
	}

	.widget {
		margin: 0 0 1.5em;
	}
	h1 {
		font-size: 44px;
		line-height: 54px;
		font-style: normal;
		font-family: 'Inter', sans-serif;
		font-weight: 600;
		margin: 0 0 20px;
	}
	@media (min-width: 992px) {
		.footer-area .footer-about {
			margin-right: 40px;
		}
	}

	.footer-area .footer-about {
		margin-bottom: 28px;
	}
	.widget ul {
		list-style-type: none;
		margin: 0px;
		padding: 0px;
	}
	.footer-area .footer-social li {
		display: inline-block;
		margin-right: 7px;
		margin-bottom: 0px;
		padding-bottom: 0px;
		transition: 0.31s;
		position: relative;
		line-height: 1.6;
	}
	.footer-top-area ul li {
		margin-bottom: 8px;
		padding-bottom: 8px;
		position: relative;
		line-height: 1.6;
	}
	.footer-area .footer-social li a {
    	display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		width: 40px;
		font-size: 15px;
		text-align: center;
		color: rgb(152, 155, 173);
		background: transparent;
		border-width: 1px;
		border-style: solid;
		border-color: rgb(152, 155, 173);
		border-image: initial;
		border-radius: 50%;
		transition: 0.4s;
		text-decoration: none;
		color: #989bad;
	}
	.container .row{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.footer-social li a svg{
		width: 16px;
		height:16px;
	}
	.footer-copyright-area {
		font-size: 17px;
		text-align: center;
		position: relative;
		border-top: 1px solid rgb(43, 46, 66);
		padding: 25px 0px;
	}
	.copyright-area {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}
	.footer-area .copyright {
		color: #989bad;
	}

	.footer-area .copyright {
		color: rgb(152, 155, 173);
		text-align: center;
	}
	.copyright-area .widget {
		margin-bottom: 0px;
	}
	.copyright-area .copyright-menu ul {
		display: inline-flex;
		align-items: center;
		gap: 12px;
	}
	.copyright-area .copyright-menu ul li {
		margin-bottom: 0px;
		padding-bottom: 0px;
	}
	.footer-top-area .copyright-area .copyright-menu ul li:first-child a {
		padding-left: 0px;
	}
	.footer-top-area .widget ul.menu li a {
		
		display: inline-block;
		position: relative;
		transition: 140ms ease-in-out;
	}
	.footer-top-area .widget a{
		color: #989bad;
	}
	.rt_footer_social_widget{
		margin-bottom: 60px !important;
	}
</style>